import { Injectable } from '@angular/core';
import { CmsmaServicePkg } from './cmsmaPkg.service';

@Injectable({
  providedIn: 'root',
})
export class CmsmaService extends CmsmaServicePkg {
  constructor() {
    super();
  }
}
